import React from 'react';
import { isNil } from 'lodash';

import {
  CounterContainer,
  StyledIconButton,
  StyledInput,
} from './Counter.style';

export interface CounterProps {
  input: {
    name: string;
    value: number;
    onChange: (value: number) => any;
    disabled?: boolean;
    min?: number;
    max?: number;
  };
}

const Counter = ({ input }: CounterProps) => {
  const minReached = !isNil(input.min) && input.value - 1 < input.min;
  const maxReached = !isNil(input.max) && input.value + 1 > input.max;

  return (
    <CounterContainer>
      <StyledIconButton
        name="removeCircleUnfilled"
        onClick={(e) => {
          e.preventDefault();
          input.onChange(input.value - 1);
        }}
        isDisabled={minReached || input.disabled}
      />
      <StyledInput type="number" readOnly value={input.value} />
      <StyledIconButton
        name="addCircleUnfilled"
        onClick={(e) => {
          e.preventDefault();
          input.onChange(input.value + 1);
        }}
        isDisabled={maxReached || input.disabled}
      />
    </CounterContainer>
  );
};

export default Counter;
